import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Gallery } from "@/components/Gallery";
import { Manifesto } from "@/components/Manifesto";
import { About } from "@/components/About";
import { Testimonials } from "@/components/Testimonials";
import { SwatchRange } from "@/components/SwatchRange";
import { QuoteForm } from "@/components/QuoteForm";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { StickyCTA } from "@/components/StickyCTA";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-lec-bone font-sans text-lec-ink">
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <Services />
        <Gallery />
        <Manifesto />
        <About />
        <Testimonials />
        <SwatchRange />
        <QuoteForm />
        <Contact />
      </main>
      <Footer />
      <StickyCTA />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
